import { Component,ViewChild } from '@angular/core';
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { Router,ActivatedRoute } from "@angular/router";
import { WebOrderService } from '../../services/web-order.service';
import { WebProductAdmin } from '../../models/web-product.model';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ToasterService } from "../../../../common/services/toaster.service";
import { environment } from '../../../../../environments/environment.prod';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-web-product-edit-page',
  templateUrl: 'web-product-edit.page.html',
  styleUrls: [
    './web-product-edit.page.scss',
  ]
})
export class WebProductEditPage {
  selectedFunction:string;
  images:any;
  selectedImage:string;
  loading:boolean=true ;
  apiBaseUrl = environment.apiUrl;
   webProductAdmin:WebProductAdmin;
     displayedDescription: SafeHtml = '';
   productType:number;
    constructor(
        private webOrderService: WebOrderService,
        private toasterService: ToasterService,
       private route: ActivatedRoute,
       private modalController:ModalController,
       private sanitizer: DomSanitizer,
        private router: Router
      ) { 
  
    }
 ngOnInit() {
 this.selectedFunction="update";
   this.loadData();
  }
  async loadData() {
const typeParam = this.route.snapshot.paramMap.get('type');
const action = this.route.snapshot.paramMap.get('action');
const isAction = action === 'true';
if (typeParam !== null) {
  this.productType = parseInt(typeParam, 10);
if(this.productType==null){
  this.productType=3;
}
this.images=await this.webOrderService.getWebProductImages();  

 var response=await this.webOrderService.getWebProduct(this.route.snapshot.paramMap.get('id'),this.productType,isAction);  
   
   if(response !=null && response.length>0){
    this.webProductAdmin=response[0];
   
        this.loading=true;
    if (this.images.includes(this.webProductAdmin.imageFile)) {
      
        this.selectedImage = this.webProductAdmin.imageFile;
      } else {
        this.selectedImage = null; 
      }
    }
  }

  }
  async UpdateProduct():Promise<void>{
    this.loading=false;
    if(this.webProductAdmin!=null && this.webProductAdmin!=undefined){
    if(this.selectedFunction=="update"){
    this.webProductAdmin.imageFile=this.selectedImage;
    var response=await this.webOrderService.updateProductItems(this.webProductAdmin);  
     if (response =='Success') {
        this.toasterService.presentToast(
          "primary",
          "The Web Product were updated.",
          "Success"
        );
       this.loading=true;
      } else {
        this.toasterService.presentToast(
          "danger",
          `Error Updating Web Product. ${response}`,
          "Error"
        );
           this.loading=true;
      }
      }else{
 const modal = this.modalController.create({
                   component: ConfirmationPopupComponent,
                   cssClass: "min-width-modal",
                   componentProps: {
                    productCode: this.webProductAdmin.productCode,
                    tableName:"Web_Products",
                },
                   showBackdrop: true,
                   backdropDismiss: true,
                   keyboardClose: true,
                   swipeToClose: true,
                 
                 });
            (await modal).present();
               const {data} = await (await modal).onDidDismiss();
   if(data){
     var response=await this.webOrderService.deleteProductItems(this.webProductAdmin.productCode,this.webProductAdmin.productType); 
     if (response =='Success') {
        this.toasterService.presentToast(
          "primary",
          " The Item was Deleted from the Web Products Table! ",
          "Success"
        );
           this.loading=true;
           
           this.router.navigate(['/admin-page/web-product-admin']);
      } else {
        this.toasterService.presentToast(
          "danger",
          `Error Deleting Web Product.}`,
          "Error"
        );  
           this.loading=true;
              }
       }

      }
  }
  else{
     this.toasterService.presentToast(
          "danger",
          `Web Product Code not Found.}`,
          "Error"
        );  
           this.loading=true;
  }
     this.loading=true;
}
 getImageUrl(imageName: string): string {
  
    if (!imageName) return '';
    return `${this.apiBaseUrl}/Images/prodimg/${imageName}`;
  }
    displayHtml(): void {
      this.displayedDescription = this.sanitizer.bypassSecurityTrustHtml(this.webProductAdmin.description);
  }
} 